import { render, staticRenderFns } from "./cheack-phone.vue?vue&type=template&id=3519cf6f&scoped=true&"
import script from "./cheack-phone.vue?vue&type=script&lang=js&"
export * from "./cheack-phone.vue?vue&type=script&lang=js&"
import style0 from "./cheack-phone.vue?vue&type=style&index=0&id=3519cf6f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3519cf6f",
  null
  
)

export default component.exports